import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetBO } from '../../pages.modal';
import { ManageService } from '../manage-service.service';
import { ActivityDataservice } from './activitydateservice';
import { functionpermission, saveActivityBO } from '../manage-service.modal';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
 export class ActivityComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridActivityGroup') public gridActivityGroup: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  isSaveorUpdateBoolean:boolean=false;
 saveactivity: saveActivityBO = new saveActivityBO();
  MSFilterBo: GetBO = new GetBO();
  fp:functionpermission=new functionpermission()

  constructor(public DateService: ActivityDataservice,
    public Msservice: ManageService,
    public global: GlobalComponent, public toasterservice: ToastrService) {
    this.GridList=DateService;    
  }

  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.MSFilterBo.field="activityName";
    this.MSFilterBo.orderColumn="activityName";
    this.getActivityFilter();
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Manage Services");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.Msservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  // ................................................dataChangeActivity..............................................
  public dataChangeActivity(SG): void {
    let val = (SG.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((SG.sorted || []).length) {
        this.MSFilterBo.orderColumn = SG.sorted[0].name;
        this.MSFilterBo.orderType = SG.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && SG.action.action != "clearFilter") {
      this.MSFilterBo.value = SG.action.currentFilterObject.value;
      this.MSFilterBo.field = SG.action.currentFilterObject.field;
      this.MSFilterBo.matchCase = SG.action.currentFilterObject.matchCase;
      this.MSFilterBo.operator = SG.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && SG.action.action == "clearFilter") {
        this.MSFilterBo.field = "activityName";
        this.MSFilterBo.matchCase = false;
        this.MSFilterBo.operator = "contains";
        this.MSFilterBo.value = "";
        this.MSFilterBo.type = "string";
      }
    }
    this.getActivityFilter();
    if (val == "paging" && SG.action.name == "actionBegin") {
     
    }
  }
    //.........................................onActionActivity.....................................................
    public onActionActivity(SG) {
      this.MSFilterBo.currentpageno = this.gridActivityGroup.pagerModule.pagerObj.currentPage;
      this.MSFilterBo.pageitem = this.gridActivityGroup.pagerModule.pagerObj.pageSize;
      if (SG.name == "actionBegin" && SG.requestType == "filterbeforeopen") {
        this.MSFilterBo.type = SG.columnType
      }
    }
  //...........................................getDetails..........................................
  getDetails(saveBos: any) {
    this.saveactivity = JSON.parse(JSON.stringify(saveBos));

  }
  //............................................Refresh...................................................
  Refresh() {
     this.saveactivity = new saveActivityBO();
    this.getActivityFilter();

  }

  //.........................................getActivityFilter.............................................
  getActivityFilter() {
    this.DateService.execute(this.MSFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridActivityGroup.height = '500';
      }
      else {
        this.gridActivityGroup.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateActivity .............................................
  SaveOrUpdateActivity () {
    this.isSaveorUpdateBoolean=true;
     let savepayload: saveActivityBO = JSON.parse(JSON.stringify(this.saveactivity));
     savepayload.id = this.saveactivity.id;
    this.Msservice.saveActivity(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
         if (this.saveactivity.id == '00000000-0000-0000-0000-000000000000') {
           this.toasterservice.success('Activity saved successfully!');
          setTimeout(() => {
             this.toasterservice.clear();
           }, 8000);

        }
         else if (this.saveactivity.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Activity updated successfully!');
           setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openActivityModal').click();
         this.saveactivity = new saveActivityBO();
        this.getActivityFilter();
     }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showActivityColumns() {
    this.gridActivityGroup.columnChooserModule.openColumnChooser(200, 50);
  }
  public ContactId:string;

  setDeleteId(value) {
    this.ContactId = value;    
  }
  //..........................................DeleteServiceActivity ...........................................................
  DeleteActivity () {
    let params = new URLSearchParams();
     params.append("activityId", this.ContactId);
    this.Msservice.DeleteActivity(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Service Activity deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeActivityModal').click();
      this.getActivityFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  
  clearActivity() {
    this.saveactivity = new saveActivityBO();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

